import { FooterSection } from "./types";

export default async function fetchFooter(): Promise<FooterSection[]> {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/footer?${process.env.NEXT_PUBLIC_API_QUERY_PARAMS}`,
    { cache: "no-store" }
  );
  if (!response.ok) {
    throw new Error("Failed to fetch footer sections");
  }
  return response.json();
}
